import { AuthContextState } from '@/types/auth'
import { atom } from 'jotai'

export const sessionAtom = atom<AuthContextState>({
  session: undefined,
  account: undefined,
  organization: undefined
})
